export const CarouselProductAttributes = {
    Size: 'size',
    Dosage: 'dosage',
    Flavor: 'flavor',
    FlavorSize: 'flavorSize',
};
export const CarouselImageVariants = {
    Simple: 'simple',
    Sidenav: 'sidenav',
};
export const CarouselTextVariants = {
    Content: 'content',
    Quote: 'quote',
};
export const CarouselProductVariants = {
    Light: 'light',
    Dark: 'dark',
};
export const CarouselSectionTypes = {
    Text: 'text',
    Image: 'image',
    Product: 'product',
    Education: 'education',
};
